/**
 * AEPStatsCards Component
 * Displays statistics cards for AEP (Ergonomic Analysis)
 */
import { Card, CardContent } from '../ui/card';
import { FileSpreadsheet, CheckCircle2, AlertTriangle, Target } from 'lucide-react';

const AEPStatsCards = ({ aeps }) => {
  const totalAeps = aeps.length;
  const adequateCount = aeps.filter(a => {
    const items = a.checklist || [];
    const inadequate = items.filter(i => i.status === 'inadequado' || i.status === 'inadequate').length;
    return inadequate === 0;
  }).length;
  const withIssuesCount = totalAeps - adequateCount;
  const avgScore = totalAeps > 0 
    ? Math.round(aeps.reduce((acc, a) => {
        const items = a.checklist || [];
        const adequate = items.filter(i => i.status === 'adequado' || i.status === 'adequate').length;
        return acc + (items.length > 0 ? (adequate / items.length) * 100 : 0);
      }, 0) / totalAeps)
    : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="aep-stats">
      <Card className="bg-gradient-to-br from-blue-500 to-blue-600 text-white">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <FileSpreadsheet className="w-8 h-8 opacity-80" />
            <div>
              <p className="text-sm opacity-80">Total AEPs</p>
              <p className="text-2xl font-bold">{totalAeps}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-emerald-500 to-emerald-600 text-white">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <CheckCircle2 className="w-8 h-8 opacity-80" />
            <div>
              <p className="text-sm opacity-80">Adequados</p>
              <p className="text-2xl font-bold">{adequateCount}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-amber-500 to-amber-600 text-white">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-8 h-8 opacity-80" />
            <div>
              <p className="text-sm opacity-80">Com Pendências</p>
              <p className="text-2xl font-bold">{withIssuesCount}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-purple-500 to-purple-600 text-white">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <Target className="w-8 h-8 opacity-80" />
            <div>
              <p className="text-sm opacity-80">Conformidade Média</p>
              <p className="text-2xl font-bold">{avgScore}%</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AEPStatsCards;
